var AbstractSegmentData = require("./../../abstract/abstractSegmentData.js");
var lib_core = require("lib-core");

var SchematicSegmentData = function(startVertex, endVertex){
    var self = this;

    AbstractSegmentData.call(this, startVertex, endVertex);

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        function(){
            var poly = null;
            if(self.startVertex() && self.endVertex()) {
                poly = self.getSegment().toPolygon(1);
            }
            return poly;
        },
        [this.startVertex, this.endVertex]
    );
    this.boundingBox = this.cachedFunction("boundingBox",
        function () { return self.segmentedGeometry().getBB(); },
        [this.segmentedGeometry]
    );
};
lib_core.inherit(SchematicSegmentData, AbstractSegmentData);
lib_core.JsonParser.registerClass(SchematicSegmentData, "SchematicSegmentData");

module.exports = SchematicSegmentData;

SchematicSegmentData.prototype.isHorizontal = function(){
    return (this.startVertex().getY() == this.endVertex().getY());
};

SchematicSegmentData.prototype.isVertical = function(){
    return (this.startVertex().getX() == this.endVertex().getX());
};
